<template>
  <b-tab :title="$store.state.localization.data.mainPage.fuelTankCard.mainTabLabel" active>
    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.idLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        readonly
        v-model="fuelTankCard.vehicleId"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.nameLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        v-model="fuelTankCard.name"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.fuelDepoLabel"
      label-for="input-horizontal"
    >
      <b-form-select
        v-model="fuelTankCard.fuelDepoId"
        :options="fuelDeposOptions"
        style="font-size: 13px"
      ></b-form-select>
    </b-form-group>

    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.descriptionLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        v-model="fuelTankCard.description"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.noteLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        v-model="fuelTankCard.note"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.fuelTypeLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        readonly
        v-model="fuelTankCard.fuelType"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.fuelMarkLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        readonly
        v-model="fuelTankCard.fuelMark"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.fuelTankVolumeLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        type="number"
        min="0"
        v-model="fuelTankCard.tankVolume"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.fuelTankHeightLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        type="number"
        min="0"
        v-model="fuelTankCard.tankHeight"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.fuelTankTypeLabel"
      label-for="input-horizontal"
    >
      <b-form-select
        v-model="fuelTankCard.tankType"
        style="font-size: 13px"
        :options="tankTypes"
      ></b-form-select>
    </b-form-group>

    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.maxFuelHeightLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        type="number"
        min="0"
        v-model="fuelTankCard.maxFuelHeight"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.minFuelHeightLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        type="number"
        min="0"
        v-model="fuelTankCard.minFuelHeight"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.maxWaterHeightLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        type="number"
        min="0"
        v-model="fuelTankCard.maxWaterHeight"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.minWaterHeightLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        type="number"
        min="0"
        v-model="fuelTankCard.minWaterHeight"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.fuelDensityLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        type="number"
        min="0"
        max="1"
        v-model="fuelTankCard.fuelDensity"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

     <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.additionalInfoLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        v-model="fuelTankCard.additionalInfo"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

     <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.minBeginFuelCharge"
      label-for="input-horizontal"
    >
      <b-form-input
        v-model="fuelTankCard.minBeginFuelCharge"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

     <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.maxEndFuelCharge"
      label-for="input-horizontal"
    >
      <b-form-input
        v-model="fuelTankCard.maxEndFuelCharge"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

     <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.minFuelCharge"
      label-for="input-horizontal"
    >
      <b-form-input
        v-model="fuelTankCard.minFuelCharge"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

     <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.minBeginFuelDischarge"
      label-for="input-horizontal"
    >
      <b-form-input
        v-model="fuelTankCard.minBeginFuelDischarge"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

     <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.maxEndFuelDischarge"
      label-for="input-horizontal"
    >
      <b-form-input
        v-model="fuelTankCard.maxEndFuelDischarge"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

     <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.fuelTankCard.minFuelDischarge"
      label-for="input-horizontal"
    >
      <b-form-input
        v-model="fuelTankCard.minFuelDischarge"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>

  </b-tab>
</template>

<script>
export default {
  name: "FuelTankCardMainTab",
  props: {
    fuelTankCard: Object,
    fuelDepos: Array,
  },
  computed: {
    tankTypes() {
      const options = [];

      for (
        let i = 0;
        i <
        this.$store.state.localization.data.mainPage.fuelTankCard
          .fuelTankTypeDropdown.length;
        i++
      ) {
        options.push({
          value: i,
          text: this.$store.state.localization.data.mainPage.fuelTankCard
            .fuelTankTypeDropdown[i],
        });
      }
      return options;
    },
    fuelDeposOptions() {
      const options = [];

      for (let i = 0; i < this.fuelDepos.length; i++) {
        options.push({
          value: this.fuelDepos[i].id,
          text: this.fuelDepos[i].name,
        });
      }

      return options;
    },
  },
};
</script>
